import React from 'react';
import { ActionIcon, Box, Center, Paper, Stack, Text } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { useAppContext } from '../contexts/AppContext';
import ProjectSidebar from './sidebar/ProjectSidebar';
import BuurtSidebar from './sidebar/BuurtSidebar';
import NewStationForm from './sidebar/NewStationForm';
import RegioSidebar from './sidebar/RegioSidebar';
import GemeenteSidebar from './sidebar/GemeenteSidebar';

export default function Sidebar() {
  const {
    sidebarOpen, setSidebarOpen,
    selectedProject,
    selectedBuurt,
    selectedRegio,
    selectedGemeente,
    newStation,
  } = useAppContext();

  // Responsief: op smalle schermen (tablet) neemt het paneel de resterende
  // breedte naast de toolbar in, op desktop de vaste 350px.
  const { width: viewportBreedte } = useViewportSize();
  const paneelBreedte = Math.min(350, Math.max(240, (viewportBreedte || 1024) - 64 - 28));

  // De panelen regelen hun eigen kop en padding (bouwstenen.js); alleen het
  // stationsformulier en de lege staat krijgen hier nog een kader.
  const renderContent = () => {
    if (sidebarOpen && selectedProject) return <ProjectSidebar />;
    if (sidebarOpen && selectedBuurt) return <BuurtSidebar />;
    if (newStation) return <Box p="md"><NewStationForm /></Box>;
    if (sidebarOpen && selectedRegio) return <RegioSidebar />;
    if (sidebarOpen && selectedGemeente) return <GemeenteSidebar />;
    // Lege staat: uitleg i.p.v. ontwikkelaars-placeholder
    return (
      <Center h="80%" px="md">
        <Stack gap="xs" align="center">
          <Text size="2rem">🗺️</Text>
          <Text fw={600} ta="center">Niets geselecteerd</Text>
          <Text size="sm" c="dimmed" ta="center">
            Klik op een gemeente, buurt of station op de kaart, of gebruik de
            zoekbalk bovenaan om iets te openen.
          </Text>
        </Stack>
      </Center>
    );
  };

  return (
    <>
      <Paper
        shadow="md"
        radius={0}
        style={{
          position: 'absolute', top: 0, left: sidebarOpen ? 64 : -(paneelBreedte + 16),
          width: paneelBreedte, height: '100vh', zIndex: 2, transition: 'left 0.3s',
          padding: 0, boxSizing: 'border-box', overflowY: 'auto',
        }}
      >
        {renderContent()}
      </Paper>
      <ActionIcon
        onClick={() => setSidebarOpen(o => !o)}
        variant="white"
        size="lg"
        aria-label={sidebarOpen ? 'Sluit zijvenster' : 'Open zijvenster'}
        style={{
          position: 'absolute', top: '50%', left: sidebarOpen ? 64 + paneelBreedte : 64,
          transform: 'translateY(-50%)', zIndex: 3, height: 60, width: 28,
          borderRadius: '0 8px 8px 0', transition: 'left 0.3s',
          boxShadow: '2px 2px 8px rgba(0,0,0,0.10)',
        }}
      >
        {sidebarOpen ? '◀' : '▶'}
      </ActionIcon>
    </>
  );
}
